import React, { useEffect, useState } from "react";
import {
  InputFilterWrapper,
  PropertyQuantity,
  Title,
  Wrapper,
  FilterButton,
} from "./styles";
import SearchBar from "./SearchBar";
import SearchFilter from "./Buttonfilters.tsx/Buttonfilters";

interface IProps {
  numberOfProperties: number;
  hasSelectedProperty: boolean;
  filtersQuantity?: number;
  onFiltersButtonClick: () => void;
  city?: string;
  uf?: string;
  neighborhood?: string;
  searchedNeighborhood?: string;
  fellBackToCity?: boolean;
}

export default function TitleSearch({
  numberOfProperties,
  hasSelectedProperty,
  onFiltersButtonClick,
  city: propCity,
  uf: propUf,
  neighborhood: propNeighborhood,
  searchedNeighborhood: propSearchedNeighborhood,
  fellBackToCity = false,
}: IProps) {
  const [city, setCity] = useState(propCity || null);
  const [uf, setUf] = useState(propUf || null);
  const [neighborhood, setNeighborhood] = useState(propNeighborhood || null);
  const [searchedNeighborhood, setSearchedNeighborhood] = useState(
    propSearchedNeighborhood || null
  );

  const getParamsFromURL = () => {
    const searchParams = new URLSearchParams(window.location.search);
    return {
      newCity: searchParams.get("city") || null,
      newUf: searchParams.get("UF") || null,
      newNeighborhood: searchParams.get("neighborhood") || null,
    };
  };

  useEffect(() => {
    const { newCity, newUf, newNeighborhood } = getParamsFromURL();
    setCity(newCity);
    setUf(newUf);
    setSearchedNeighborhood(newNeighborhood);
    setNeighborhood(propNeighborhood || newNeighborhood);
  }, [propNeighborhood, propCity, propUf, propSearchedNeighborhood]);

  const getQuantityLabel = () => {
    if (hasSelectedProperty) {
      return "1 imóvel selecionado";
    }

    if (numberOfProperties === 0) {
      return "Nenhum imóvel encontrado";
    }

    if (numberOfProperties === 1) {
      return "1 imóvel encontrado";
    }

    if (fellBackToCity && searchedNeighborhood) {
      return `${numberOfProperties} imóveis encontrados em ${city}, ${uf} (sem resultados em ${searchedNeighborhood})`;
    }

    if (neighborhood) {
      return `${numberOfProperties} imóveis encontrados em ${neighborhood}, ${city} - ${uf}`;
    }

    return `${numberOfProperties} imóveis encontrados em ${city}, ${uf}`;
  };

  return (
    <Wrapper>
      <Title>Resultados da Pesquisa</Title>
      <PropertyQuantity>{getQuantityLabel()}</PropertyQuantity>
      <InputFilterWrapper>
        <div
          style={{
            display: "flex",
            gap: "16px",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <SearchBar />
          <SearchFilter />
          <FilterButton onClick={onFiltersButtonClick}>Mais filtros</FilterButton>
        </div>
      </InputFilterWrapper>
    </Wrapper>
  );
}
